import { FC, useContext } from "react";
import { BreakPointContext } from "../../../../context/BreakPointContext";
import { UserGoodsControl } from "../../../../../domain/control/Goods";
import { GoodsControlList } from "../../../data-display/goods-control-list";
import { GoodsControlTable } from "../../../data-display/goods-control-table";

type Props = {
  goodsControlList?: UserGoodsControl[];
  onSelect: (item: UserGoodsControl) => void;
};

export const UserGoodsControlDataName = "UserGoodsControlData";

export const UserGoodsControlData: FC<Props> = ({
  goodsControlList,
  onSelect,
}) => {
  const screenSize = useContext(BreakPointContext);
  if (screenSize.isMobile) {
    return (
      <GoodsControlList
        name={UserGoodsControlDataName}
        onSelect={onSelect}
        goodsControlList={goodsControlList}
      />
    );
  } else {
    return (
      <GoodsControlTable
        name={UserGoodsControlDataName}
        goodsControlList={goodsControlList}
        onSelect={onSelect}
      />
    );
  }
};
